import {Box, Skeleton} from "@mui/material";

const HomeSkeleton: React.FC = (): JSX.Element => {
    return (
        <Box
            sx={{
                padding: 8,
                display: "flex",
                flexDirection: "column",
                maxWidth: 800,
            }}
        >
            <Box>
                <Skeleton variant="rectangular" width={500} height={60}/>
                <Skeleton
                    style={{marginTop: 10}}
                    variant="rectangular"
                    width={500}
                    height={400}
                />
            </Box>
        </Box>
    );
};

export default HomeSkeleton;
